module.exports = __webpack_public_path__ + "static/media/key-message-choice.c3f9f65d.svg";